import React from 'react'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './Rating.module.scss'

interface IRatingProps {
  rating: number
}

const Rating = ({ rating }: IRatingProps) => {
  const { t } = useSurveyLocale()
  const filled = Math.round(rating || 0)
  return (
    <div
      className={style.rating}
      aria-label={t<(rating: number) => string>('questions', 'ec', 'chewy', 'ratedOutOf5')(rating || 0)}
    >
      {[1, 2, 3, 4, 5].map(n => (
        <i key={n} className={`pi ${n <= filled ? 'pi-star-fill' : 'pi-star'} ${style.star}`} />
      ))}
    </div>
  )
}

export default Rating
